import { WifiOffIcon } from "lucide-react";
import useOnlineStatus from "../hooks/useOnlineStatus";

const OfflineWarning = () => {
  const { isNavigatorOnline } = useOnlineStatus();

  return (
    <div className="p-2 bg-danger text-sm flex items-center justify-center gap-3 z-50">
      <WifiOffIcon className="h-5" />

      {!isNavigatorOnline && (<p>Ops! Não estamos conseguindo conectar à internet.</p>)}

      {isNavigatorOnline && (<p>Ops! Nossos servidores estão indisponíveis, entre em contato com o suporte ou tente novamente mais tarde.</p>)}
    </div>
  );
};

export default OfflineWarning;
